import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, LogIn } from 'lucide-react';
import { AuthUser } from '@aws-amplify/ui';
import Navigation from './Navigation';
import EmergencyBanner from '../emergency/EmergencyBanner';

interface HeaderProps {
  activeTab: string;
  onTabChange: (tab: 'home' | 'providers' | 'global' | 'about') => void;
  user: AuthUser | null;
  onSignOut?: () => void;
  onSignInClick: () => void;
}

export default function Header({ 
  activeTab, 
  onTabChange, 
  user, 
  onSignOut,
  onSignInClick 
}: HeaderProps) {
  return (
    <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-lg shadow-sm">
      {/* Emergency Banner */}
      <div className="bg-gradient-to-r from-red-50 to-red-100 border-b border-red-200">
        <EmergencyBanner />
      </div>

      {/* Main Navigation */}
      <div className="border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <Activity className="h-8 w-8 text-mint-600" />
                <span className="ml-2 text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-sage-600 to-mint-600">
                  Gprov
                </span>
              </Link>
              <div className="ml-8">
                <Navigation 
                  activeTab={activeTab} 
                  onTabChange={onTabChange}
                  isAuthenticated={!!user}
                />
              </div>
            </div>

            {/* Auth Section */}
            <div className="flex items-center gap-3">
              {user ? (
                <div className="flex items-center gap-4">
                  <span className="text-sm text-gray-700">
                    Welcome, {user.username}
                  </span>
                  <button
                    onClick={onSignOut}
                    className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                  >
                    Sign Out
                  </button>
                </div>
              ) : (
                <button
                  onClick={onSignInClick}
                  className="inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium text-white bg-gradient-to-r from-sage-600 to-mint-600 hover:from-sage-700 hover:to-mint-700 shadow-sm transition-all duration-200"
                >
                  <LogIn className="w-4 h-4 mr-2" />
                  Sign In
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
